import axios from "axios";

export interface StatesResponse {
  id: number;
  sigla: string;
  nome: string;
  regiao: {
    id: number;
    sigla: string;
    nome: string;
  };
}

export interface CountriesResponse {
  id: {
    M49: number;
  };
  nome: string;
}

export interface CitiesResponse {
  id: number;
  nome: string;
}

export interface CepResponse {
  cep: string;
  logradouro: string;
  complemento?: string;
  unidade?: string;
  bairro: string;
  localidade: string;
  uf: string;
  estado: string;
  regiao: string;
  ibge: string;
  gia?: string;
  ddd: string;
  siafi: string;
  erro?: boolean;
}

export async function fetchCep(cep: string): Promise<CepResponse> {
  const { data } = await axios.get<CepResponse>(
    `https://viacep.com.br/ws/${cep}/json`
  );
  return data;
}

export async function fetchStates(): Promise<StatesResponse[]> {
  const { data } = await axios.get<StatesResponse[]>(
    "https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome"
  );
  return data;
}

export async function fetchCountries(): Promise<CountriesResponse[]> {
  const { data } = await axios.get<CountriesResponse[]>(
    "https://servicodados.ibge.gov.br/sesi/portal-externo/v1/localidades/paises"
  );

  return data.sort((a, b) => {
    const nameA = a.nome.toUpperCase();
    const nameB = b.nome.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
}

export async function fetchCities(stateId: number): Promise<CitiesResponse[]> {
  const { data } = await axios.get<CitiesResponse[]>(
    `https://servicodados.ibge.gov.br/sesi/portal-externo/v1/localidades/estados/${stateId}/municipios`
  );

  return data.sort((a, b) => {
    const nameA = a.nome.toUpperCase();
    const nameB = b.nome.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
}
